import { render, staticRenderFns } from "./dealerstatisticsByMonth.vue?vue&type=template&id=63874b16&"
import script from "./dealerstatisticsByMonth.vue?vue&type=script&lang=js&"
export * from "./dealerstatisticsByMonth.vue?vue&type=script&lang=js&"
import style0 from "./dealerstatisticsByMonth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports